export default __webpack_public_path__ + "static/media/partner (5).654482ec.png";